import { render, staticRenderFns } from "./tabitha.vue?vue&type=template&id=8c18a5a2&scoped=true&"
import script from "./tabitha.vue?vue&type=script&lang=js&"
export * from "./tabitha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c18a5a2",
  null
  
)

export default component.exports